import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, ReplaySubject } from 'rxjs';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
import { ResponseCargueI } from 'src/app/modelos/ResponseCargue';
import { ApiService } from 'src/app/servicios/api/api.service';
import { CarguemasivofuenteService } from 'src/app/servicios/fuentes/carguemasivo/carguemasivofuente.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-carguem',
  templateUrl: './carguem.component.html',
  styleUrls: ['./carguem.component.css']
})
export class CarguemComponent implements OnInit, AfterViewInit {

  uploadedFiles : Array<File>;

  btnCargar : Boolean;
  cargar : Boolean;
  btnContinuar : Boolean;
  continuar : Boolean;
  errorcargue : Boolean;
  spinner : Boolean;

  idFuente : BigInteger;
  idUsuarioCarga : String;
  RolUsuarioCarga : String;

  file: any;
  contenidoDocumento: string;

  RespuestaCargueMasivo: ResponseCargueI = new ResponseCargueI;

  PeriodoActivo : PeriodoReporteI = new PeriodoReporteI;
  EstadoInfomacionFuente : EstadoInfoChvI = new EstadoInfoChvI;

  ReporPedRefSi : Boolean;
  ReporPedRefNo : Boolean;
  @ViewChild('openmodalperidoact') openmodalperidoact: ElementRef;
  @ViewChild('closemodalperidoact') closemodalperidoact: ElementRef;
  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('closemodacargando') closemodacargando: ElementRef;

  pdfUrl: string = 'assets/Formatos/Guia diligenciamiento_CHV.pdf';
  xlsxUrl: string = 'assets/Formatos/Plantilla CHV Fuentes.xlsx';
  xlsxUrlSuper: string = 'assets/Formatos/Plantilla CHV Supersolidaria.xlsx';

  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private carguemasivofuenteService: CarguemasivofuenteService,
    private toastr: ToastrService,
    private appService:AppServiceService
  ) { }

  ngOnInit(): void {
    this.desactivarCierreTeclaEsc();
    this.ReporPedRefSi = false;
    this.ReporPedRefNo = false;
    this.btnCargar = true;
    this.cargar = true;
    this.btnContinuar = true;
    this.spinner = false;
    this.continuar = false;
    this.errorcargue = false;
    this.RolUsuarioCarga = localStorage.getItem('rol');
    this.api.consultarPeriodoActivoCHV().subscribe(PeriAc=>{
      this.PeriodoActivo = PeriAc;
      if(localStorage.getItem('rol') == "Fuente"){
        this.api.getUsuarioByUsername(localStorage.getItem("usuario")).subscribe(data=>{
          this.idUsuarioCarga = data.id;
          this.idFuente = data.fuente;
        });
        this.api.EstadoInfParaFuente(PeriAc.id, localStorage.getItem('idFte')).subscribe(data11=>{
          this.EstadoInfomacionFuente = data11;
          localStorage.setItem("idEstInfFte",data11.id.toString());
        });
      } else if(localStorage.getItem('rol') == "Supersolidaria"){
        this.api.getUsuarioByUsername(localStorage.getItem("usuario")).subscribe(data=>{
          this.idUsuarioCarga = data.id;
        });
      }
    });
  }

  ngAfterViewInit(){
    this.openmodalperidoact.nativeElement.click();
  }

  public uploadFile(event){
    this.btnCargar = false;
    this.file = (event.target as HTMLInputElement).files[0];

    if(this.file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      this.file.type=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      this.file.type=='application/vnd.ms-excel'){
      //console.log("Nombre del archivo: " + this.file.name + " , Tipo: " + this.file.type);
    }else{
      this.toastr.error('Solamente se permiten archivos tipo EXCEL.', 'Error!');
      return;
    }
    let comp = this;
    let reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = function () {
          comp.contenidoDocumento = reader.result.toString();
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
          return error;
        };
  }

  public guardarDocumento(){
    this.btnCargar = true;
    this.spinner = true;
    this.api.cargarArchivoCM(this.idUsuarioCarga, this.idFuente, this.file, this.contenidoDocumento).subscribe(result => {
        this.RespuestaCargueMasivo = result;
        if(result.estado == "OK"){
          this.btnContinuar = false;
          this.cargar = false;
          this.spinner = false;
          this.errorcargue = false;
          this.continuar = true;
          this.toastr.success(result.mensaje,result.estado + '!');
        } else if (result.estado == "ERROR"){
          this.btnCargar = false;
          this.cargar = true;
          this.errorcargue = true;
          this.spinner = false;
          this.toastr.error(result.mensaje,result.estado + '!');
        }
      }, error => {
        if(error.status == 500){
          this.toastr.error('Interno: informar atención usuario.','Error!');
          this.closemodacargando.nativeElement.click();
        } else {
          this.toastr.error('Cargue incorrecto.','Error!');
        }
      }
    );
  }

  public guardarDocumentoSuper(){
    this.btnCargar = true;

    this.api.cargarArchivoCMSuper(this.idUsuarioCarga, this.file, this.contenidoDocumento ).subscribe(
      result => {
        this.RespuestaCargueMasivo = result;
        if(result.estado == "OK"){
          this.btnContinuar = false;
          this.cargar = false;
          this.errorcargue = false;
          this.continuar = true;
          this.toastr.success(result.mensaje,result.estado + '!');
        } else if (result.estado == "ERROR"){
          this.btnCargar = false;
          this.cargar = true;
          this.errorcargue = true;
          this.toastr.error(result.mensaje,result.estado + '!');
        } else if (result.estado == "ADVERT"){
          this.toastr.error(result.mensaje,result.estado + 'Advertencia!');
        }
      }, error => {
        if(error.status == 500){
          this.toastr.error('Interno: informar atención usuario.','Error!');
        } else {
          this.toastr.error('Cargue incorrecto.','Error!');
        }
      }
    );
  }

  siguienteModulo(){
    this.router.navigate(['novedades']);
  }

  siguienteModulo2(){
    this.router.navigate(['consultareporte']);
  }

  download(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById("ErroresCargue"));
    XLSX.utils.book_append_sheet(workbook, ws1, "ErroresCargue");
    XLSX.writeFile(workbook, "Errores_Cargue_.xlsx");
    this.ngOnInit();
  }

  download2(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById("ErroresCargueSuper"));
    XLSX.utils.book_append_sheet(workbook, ws1, "ErroresCargue");
    XLSX.writeFile(workbook, "Errores_Cargue_Supersolidaria.xlsx");
    this.ngOnInit();
  }

  IrNovedades(){

    const isReportPending = this.ReporPedRefSi && !this.ReporPedRefNo;
    const isNoReportSelected = !this.ReporPedRefSi && this.ReporPedRefNo;
    const isBothReportOptionsSelected = this.ReporPedRefSi && this.ReporPedRefNo;
    const isNoReportOptionsSelected = !this.ReporPedRefSi && !this.ReporPedRefNo;

    if (isReportPending) {
      this.carguemasivofuenteService.validarSiFuenteChvPuedeReportarEnPeriodo(this.idUsuarioCarga, null, this.PeriodoActivo.id).subscribe(result => {
        if (result) {
          if (result.permitido) {
            this.toastr.success(result.mensaje, result.tituloMensaje);
            this.closemodalperidoact.nativeElement.click();
          }else{
            this.toastr.error(result.mensaje, result.tituloMensaje);
          }
        }
      });
    } else if (isNoReportSelected) {
      this.closemodalperidoact.nativeElement.click();
      this.router.navigate(['novedades']);
    } else if (isBothReportOptionsSelected) {
      this.toastr.warning('Seleccione solo una opción.', 'Advertencia!');
    } else if (isNoReportOptionsSelected) {
      this.toastr.warning('Seleccione una opción.', 'Advertencia!');
    }
  }

  IrNovedades2() {
    const isReportPending = this.ReporPedRefSi && !this.ReporPedRefNo;
    const isNoReportSelected = !this.ReporPedRefSi && this.ReporPedRefNo;
    const isBothReportOptionsSelected = this.ReporPedRefSi && this.ReporPedRefNo;
    const isNoReportOptionsSelected = !this.ReporPedRefSi && !this.ReporPedRefNo;

    const fechaHoy = new Date();
    const diaHoy = fechaHoy.getDate();
    const mesHoy = fechaHoy.getMonth() + 1;
    const anioHoy = fechaHoy.getFullYear();

    const [diaRecoleccion, mesRecoleccion, anioRecoleccion] = this.PeriodoActivo.fechaFinRecoleccionSuper.split("/").map(Number);

    const estaEnPeriodoDeRecoleccion = (anioHoy === anioRecoleccion && mesHoy === mesRecoleccion && diaHoy <= diaRecoleccion);

    if (isReportPending) {
      if (estaEnPeriodoDeRecoleccion) {
        this.toastr.success('Puede realizar el cargue', 'OK!');
      } else {
        this.toastr.error('Reporte fuera de calendario', 'Error!');
      }
      this.closemodalperidoact.nativeElement.click();
    } else if (isNoReportSelected) {
      this.closemodalperidoact.nativeElement.click();
      this.router.navigate(['consultareporte']);
    } else if (isBothReportOptionsSelected) {
      this.toastr.warning('Seleccione solo una opción.', 'Advertencia!');
    } else if (isNoReportOptionsSelected) {
      this.toastr.warning('Seleccione una opción.', 'Advertencia!');
    }
  }


  private desactivarCierreTeclaEsc() {
    const modalElement = document.getElementById('modal-confirma');
    if (modalElement) {
      modalElement.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  exportarExcel(idTabla:string){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById(idTabla));
    XLSX.utils.book_append_sheet(workbook, ws1, idTabla);
    XLSX.writeFile(workbook, idTabla+".xlsx");
  }



}
